// src/components/Settings.js

import React from 'react';
import Navbar from './Navbar';
import '../styles/Settings.css';

const Settings = ({ onLogout }) => {
  return (
    <div className="settings">
      <Navbar onLogout={onLogout} />
      <div className="content">
        <h1>Settings</h1>
        {/* Add your Settings component content here */}
      </div>
    </div>
  );
};

export default Settings;